import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import React from "react";
import Nav from "./nav";

const Header = () => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const toggleMenu = e => {
    const [nav] = document.getElementsByTagName("nav");
    nav.classList.toggle("view-menu");

    const [svgContainer] = document.getElementsByClassName("toggle-menu");
    svgContainer.classList.toggle("toggle-menu-on");
  };

  return (
    <header>
      <Link className="brand" to="/">
        {data.site.siteMetadata.title}
      </Link>
      <Nav></Nav>
      <div
        className="toggle-menu"
        aria-label="Toggle Menu"
        onKeyPress={toggleMenu}
        role="button"
        onClick={toggleMenu}
        tabIndex="0"
      >
        <svg viewBox="0 0 100 80" width="40" height="40">
          <rect width="100" height="20"></rect>
          <rect y="30" width="100" height="20"></rect>
          <rect y="60" width="100" height="20"></rect>
        </svg>
      </div>
    </header>
  );
};

export default Header;
